<template>
  <div class="detail-c">
    <div class="detail-top flex bg-white">
      <div class="w-80 flex justify-center items-start">
        <!-- -->
        <!-- <img alt src /> -->
        <j-image-upload bizPath="scott/pic" class="pt-20px" v-model="device.pictureObjId"></j-image-upload>
      </div>
      <div class="flex-1" id="components-form-demo-advanced-search">
        <!--   :form="form" -->
        <a-form-model
          :label-col="{ span: 5 }"
          :model="device"
          :rules="validatorRules"
          :wrapper-col="{ span: 18 }"
          @submit="handleSumbit"
          class="ant-advanced-search-form"
          ref="form"
        >
          <!--  :rules="validatorRules" -->
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-item label="设备名称">
                <a-input placeholder="请输入设备名称/表号" v-model="device.devName" />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="表号">
                <a-input class="w-full" placeholder="请输入表号" v-model="device.devTag" />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item has-feedback label="设备类型">
                <a-select placeholder="请选择设备类型" v-model="device.devTypeId">
                  <a-select-option
                    :key="`dev`+item.value"
                    :value="item.value"
                    v-for="item in devClassList"
                  >{{ item.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-item label="设备状态">
                <j-dict-select-tag dictCode="dev_life_status" placeholder="请选择设备状态" v-model="device.serviceStatus" />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="供水流域">
                <!-- <a-input class="w-full" placeholder="请输入供水流域" v-model="device.areaId" /> -->
                <a-select placeholder="请选择供水流域" v-model="device.areaId">
                  <a-select-option :key="item.value" :value="item.value" v-for="item in areaList">{{ item.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="供水流域">
                <a-select default-value="1" placeholder="请选择供水流域" v-model="device.devProcessId">
                  <a-select-option
                    :key="`dev`+item.value"
                    :value="item.value"
                    v-for="item in devProcessList"
                  >{{ item.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-item label="重要性" prop="device_importance">
                <j-dict-select-tag dictCode="device_importance" placeholder="请选择重要性" v-model="device.importance" />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="负责人">
                <!-- <j-select-multi-user :query-config="selectUserQueryConfig" v-model="device.multiUser" /> -->
                <j-select-user-by-dep :multi="false" v-model="device.multiUser"></j-select-user-by-dep>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="上级设备">
                <j-tree-select
                  dict="dev_list,dev_name,id,del_flag=0 order by sort asc"
                  hasChildField="is_leaf"
                  pid-field="parent_id"
                  pidValue
                ></j-tree-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24" :style="{ textAlign: 'right' }">
              <a-button html-type="submit" type="primary">保存</a-button>
              <a-button :style="{ marginLeft: '8px' }" @click="handleReset">重置</a-button>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
    </div>
  </div>
</template>
<script>
  import { equipment } from '@/utils/dict'
  import { selectDropList, addDevList, selectDevProcessList, selectDevClassList } from '@/api/device'
  import { httpAction, getAction } from '@/api/manage'

  export default {
    name: 'TopBaseInfo',
    data () {
      return {
        expand: false,
        //  form: this.$form.createForm(this, { name: 'top_base_info_form' }),
        device: {
          pictureObjId: ''// 设备图片
        },
        confirmLoading: false,

        validatorRules: {
        },
        devClassList: [],
        areaList: [],
        devProcessList: [],
        equipmentDict: equipment,
        selectUserQueryConfig: [],
        topUrl: {
          add: '/device/devList/add',
          edit: '/device/devList/edit',
          queryById: '/device/devList/queryById'
        }
      }
    },
    props: {
      manuList: {
        type: Array,
        default: () => []
      }
    },
    created () {
      this.getAreaList()
      this.getDevProcessList()
      this.getDevClassList()
    },
    methods: {
      handleSumbit (e) {
        e.preventDefault()

        // this.form.validateFields((err, values) => {
        //   if (!err) {
        //     console.log('Received values of form: ', values)
        //   }
        // })

        const that = this
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true
            let httpurl = ''
            let method = ''
            if (!this.device.id) {
              httpurl += this.topUrl.add
              method = 'post'
            } else {
              httpurl += this.topUrl.edit
              method = 'put'
            }
            httpAction(httpurl, this.device, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            }).finally(() => {
              that.confirmLoading = false
            })
          }
        })
      },

      handleReset () {
        this.form.resetFields()
      },

      toggle () {
        this.expand = !this.expand
      },
      getAreaList () {
        selectDropList().then(res => {
          this.areaList = res.result.records.map(item => {
            return {
              value: item.id,
              label: item.areaName
            }
          })
        })
      },
      getDevProcessList () {
        selectDevProcessList().then(res => {
          this.devProcessList = res.result.records.map(item => {
            return {
              value: item.id,
              label: item.processName
            }
          })
          this.device.devProcessId = this.devProcessList[0].value
        })
      },
      getDevClassList () {

        selectDevClassList().then(res => {
          this.devClassList = res.result.records.map(item => {
            return {
              value: item.id,
              label: item.typeName
            }
          })
          this.device.devClassId = this.devClassList[0].value
        })
      }
    }
  }
</script>
<style >

  .ant-advanced-search-form {
    padding: 24px;
  }

  .ant-advanced-search-form .ant-form-item {
    display: flex;
  }

  .ant-advanced-search-form .ant-form-item-control-wrapper {
    flex: 1;
  }
  .detail-top .ant-upload-list-picture-card .ant-upload-list-item {
    width: 200px;
    height: 200px;
  }

  #components-form-demo-advanced-search .ant-form {
    max-width: none;
  }
  #components-form-demo-advanced-search .search-result-list {
    margin-top: 16px;

    min-height: 200px;
    text-align: center;
    padding-top: 80px;
  }

</style>
